import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { competencyAPI } from '@/providers/apis/competency/competency';
import { sessionService } from '@/providers/services/auth/session';

@Component({
    name: 'gdot-preview',
    components: { 'material-icon': GoogleMaterialIcon },
})

export default class GdotPreview extends Vue {

    public isEditView = false;

    // ------------------------------------------------------------------
    // Properties
    @Prop()
    public content: any;

    public selectedItems: any = [];

    public isLoading: boolean = false;

    public originalMappingDetails: any = [];

    public mappedCompetency: any = null;
    public universalViewMode: any;

    public mappingDetails: any = [];


    private fields: any = [
        {
          key: 'serialNo',
          label: 'S.No',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'serialNo',
        },
        {
          key: 'competency',
          label: 'Competency',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'competency',
        },
        {
          key: 'gCompetency',
          label: 'GDot Competency',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'gCompetency',
        },
    ];

    // ------------------------------------------------------------------------
    // Actions

    public created() {
        this.isLoading = true;
        this.getRequestList();
        const session: any = sessionService.getSession();
        this.universalViewMode = session.permissions.indexOf('UNIVERSAL_CROSSWALK_VIEW') !== -1;
    }
    public back() {
        this.$emit('closePreview');
    }
    public onSearch(searchTerm: any) {
        if (searchTerm === '') {
            this.mappingDetails = this.originalMappingDetails;
        } else {
            this.mappingDetails = this.mappingDetails.filter((subject: any) => {
                if (subject.fw_competency_id === searchTerm) {
                    return subject.fw_competency_id === searchTerm;
                } else {
                    subject.universal_comptency_mapping.filter((ucm: any) => {
                        if (ucm.fw_comp_code === searchTerm) {
                            return ucm.fw_comp_code === searchTerm;
                        }
                    });
                }
            });
        }
    }
    public onEdit() {
        this.isEditView = true;
    }
    public onSaveDraft() {
        const params = {
            id: this.content.id,
            universal_competency_mapping: this.selectedItems,
        };
        competencyAPI.saveDraft(params).then((data) => {
            this.isEditView = false;
         });
    }
    public onPublish() {
        this.isEditView = false;
        competencyAPI.publishRequest(this.content.id).then((response) => {
            this.$emit('closePreview');
        });
        if (this.mappedCompetency) {
            competencyAPI.checkMapping(this.mappedCompetency).then((data) => {
                this.isEditView = false;
             });
        }
    }
    public onSelectCompetency(item: any, ucmItem: any) {
        item.universal_comptency_mapping.map((data: any) => {
            if (data.fw_comp_code === ucmItem.fw_comp_code) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        });
        const ucmdata = {
            grade: ucmItem.grade,
            title: ucmItem.title,
            fw_code: ucmItem.fw_code,
            distance: ucmItem.distance,
            selected: ucmItem.selected,
            certainty: ucmItem.certainty,
            comp_code: ucmItem.comp_code,
            transcript: ucmItem.transcript,
            fw_comp_code: ucmItem.fw_comp_code,
            subject_code: ucmItem.subject_code,
            universal_comp_code: ucmItem.universal_comp_code,
            universal_subject_code: ucmItem.universal_subject_code,
            id: ucmItem.id,
        };
        if (this.selectedItems.length) {
            this.selectedItems = this.selectedItems.filter((items: any) => {
                return items.id !== ucmItem.id;
            });
            this.selectedItems.push(ucmdata);
        } else {
            this.selectedItems.push(ucmdata);
        }
    }
    public onMappedCompetency(content: any) {
        const params = {
            tx_subject_code: content.item.target_subject_code,
            fw_code: content.item.target_fw_code,
        };
        this.mappedCompetency = params;
    }
    public getRequestList() {
        this.isLoading = true;
        competencyAPI.getRequestList(this.content.id).then((content) => {
           content.data.map((data: any) => {
                data.universalCompetency = data.universal_comptency_mapping.filter((universal: any) => {
                    universal.reCertainty  = universal.certainty.toFixed(4);
                    universal.id = data.id;
                    return universal && universal.selected  && universal.selected === true;
                });
           });
           this.mappingDetails = content.data;
           this.originalMappingDetails = content.data;
           this.isLoading = false;
        });
    }
}

